import script from "./LeadById.vue?vue&type=script&setup=true&lang=js"
export * from "./LeadById.vue?vue&type=script&setup=true&lang=js"

import "./LeadById.vue?vue&type=style&index=0&id=06137a4b&scoped=true&lang=css"

import exportComponent from "/builds/izee/leadservice/lead-admin-tool/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06137a4b"]])

export default __exports__